import React, { Component } from "react"

export default class SelfHarm extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Self Harm</p>
            <p className="portdesctext">A internaional reading group hosted on discord revolving around developing a critical dialect regarding luxury fashion. An attempt to invite varying perspectives regarding fashion & have them investigated.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://discord.gg/wM5sJne" target="_blank" rel="noopener noreferrer"><p className="linktext">Discord</p></a>
        </div>
      </div>
  )
}
}
